/**
 * ConvertUtils fornece utilitários para conversão de valores.
 */

export class ConvertUtils {
  static toNumber(value: any): number {
    if (value === null || value === undefined) {
      return 0;
    }
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string' && value.trim() === '') {
      const num = Number(value);
      if (isNaN(num)) {
        return 0;
      }
      return num;
    }
    return 0;
  }
}